document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-uvi-blog-track]').forEach(function (track) {
    var wrap = track.closest('.uvi-blog-maq');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-uvi-blog-prev]');
    var next = wrap.querySelector('[data-uvi-blog-next]');
    var step = function () {
      var card = track.querySelector('.f-column');
      return card ? card.getBoundingClientRect().width + 32 : track.clientWidth * 0.34;
    };
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
  });
});
